import { Component, Input, OnInit } from '@angular/core';
import { ClaimStatusCode } from 'src/app/security-deposit/claims/models/claims.model';

@Component({
  standalone: false,
  selector: 'app-claim-status-badge',
  templateUrl: './claim-status-badge.component.html',
  styleUrls: ['./claim-status-badge.component.scss']
})
export class ClaimStatusBadgeComponent {

  @Input() claimStatusCode?: ClaimStatusCode;
  ClaimStatusCode = ClaimStatusCode;
  constructor() { }
}
